import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink'; // @ts-expect-error importing from JS file

import { FB_CONVERSION_API_LEARN_MORE_LINK } from 'ads-account-connection/lib/Constants'; // @ts-expect-error importing from JS file

import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink'; // @ts-expect-error importing from JS file

import { KBArticles } from 'AdsUI/lib/Constants';

/**
 * Banner displayed when the user is creating a new Facebook CAPI event.
 */
const FacebookCapiEventCreationBanner = ({
  close
}) => {
  return /*#__PURE__*/_jsxs(UIAlert, {
    use: "inline",
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "events.creation.CRM_EVENT.lifecycleStages.facebookCapiBannerTitle"
    }),
    closeable: true,
    onClose: close,
    className: "m-top-4",
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "events.creation.CRM_EVENT.lifecycleStages.facebookCapiBannerBody_jsx",
      options: {
        href: FB_CONVERSION_API_LEARN_MORE_LINK,
        external: true
      },
      elements: {
        Link: UILink
      }
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(KnowledgeBaseLink, {
        kbArticle: KBArticles.SYNC_FB_CONVERSION_EVENTS,
        context: "create-event-panel-fb-capi-banner"
      })
    })]
  });
};

export default FacebookCapiEventCreationBanner;